import { Area } from "./Area";
import { DateTime_fromTransferable, DateTime_toTransferable } from "./DateTime";
export function GridRequest_toTransferable(req) {
    return {
        ...req,
        area: req.area.toTransferable(),
        datetime: DateTime_toTransferable(req.datetime),
        boundingBoxLimit: req.boundingBoxLimit ? req.boundingBoxLimit.toTransferable() : null,
    };
}
export function GridRequest_fromTransferable(req) {
    return {
        ...req,
        area: Area.fromTransferable(req.area),
        datetime: DateTime_fromTransferable(req.datetime),
        boundingBoxLimit: req.boundingBoxLimit && Area.fromTransferable(req.boundingBoxLimit),
    };
}
//# sourceMappingURL=GridRequest.js.map